export const DUAL_ACCOUNT_REPORT = 'DUAL ACCOUNT REPORT'
export const PART_D_PREDETERMINATION_REPORT = 'PART D PREDETERMINATION REPORT'
export const INBOUND_CORR_WB_REPORT = 'INBOUNDCORRWB REPORT'
export const PART_D_DUPLICATE_REPORT = 'PART D DUPLICATE REPORT'
export const PART_D_IE_REPORT = 'PART D EXCLUSION REPORT'
export const PART_D_MULTIPLE_REPORT = 'PART D MULTIPLE REVIEW REPORT'
export const RESOLVED_COMPLETED_REPORT = 'RETRO RESOLVED-DISMISSED RESOLVED-COMPLETED REPORT'
export const TRANSITIONAL_OVERRIDE_REPORT = 'TRANSITIONAL OVERRIDE REPORT'
export const UHCEI_DUPLICATE_DENIAL_REPORT = 'UHCEI DUPLICATE DENIAL REPORT'
export const XCPINDEXING_REPORT = 'XCP INDEXING REPORT'

// export reportMetaData = {
//     [DUAL_ACCOUNT_REPORT]:{
//         'SORTING':,
//         'COLUMN_NAMES':,
//     }
// }